import { markupDataParams } from "./markup";

export interface PathologyMetadata {
  manufacturer: string;
  manufacturerModelName: string;
  modality: string;
  patientAge: string;
  patientName: string;
  patientSex: string;
  pixelSpacing: number;
  studyDate: string;
  columns: number;
  rows: number;
}

export interface PathologySide {
  pathology: string;
  severity: string;
}

export interface Pathology {
  pathologyLeft: PathologySide[];
  pathologyRight: PathologySide[];
}

export interface PathologyParams {
  id: string;
  markup: {
    img: string;
    markupData: markupDataParams[];
  }[];
  mode?: string;
  metadata: PathologyMetadata;
  pathology: {
    pathologyLeft: PathologySide[];
    pathologyRight: PathologySide[];
  };
  projection: string;
  sequence: string;
  visiblePart: string;
  intern?: string;
}

export interface PathologyPutParams {
  mode?: string;
  projection: string;
  sequence: string;
  visiblePart: string;
}

export interface PathologyState {
  pathology: PathologyParams | null;
  loading: boolean;
  error: null | string;
}

export enum PathologyActionTypes {
  GET_MARKUP_PATHOLOGY = "GET_MARKUP__PATHOLOGY",
  GET_MARKUP_PATHOLOGY_SUCCESS = "GET_MARKUP_PATHOLOGY_SUCCESS",
  GET_MARKUP_PATHOLOGY_ERROR = "GET_MARKUP_PATHOLOGY_ERROR",

  GET_PATHOLOGY = "GET_PATHOLOGY",
  GET_PATHOLOGY_SUCCESS = "GET_PATHOLOGY_SUCCESS",
  GET_PATHOLOGY_ERROR = "GET_PATHOLOGY_ERROR",

  VALIDATE_PATHOLOGY = "VALIDATE_PATHOLOGY",
  VALIDATE_PATHOLOGY_SUCCESS = "VALIDATE_PATHOLOGY_SUCCESS",
  VALIDATE_PATHOLOGY_ERROR = "VALIDATE_PATHOLOGY_ERROR",

  SAVE_MARKUP_PATHOLOGY = "SAVE_MARKUP_PATHOLOGY",
  SAVE_MARKUP_PATHOLOGY_SUCCESS = "SAVE_MARKUP_PATHOLOGY_SUCCESS",
  SAVE_MARKUP_PATHOLOGY_ERROR = "SAVE_MARKUP_PATHOLOGY_ERROR",

  DELETE_PATHOLOGY = "DELETE_PATHOLOGY",
  DELETE_PATHOLOGY_SUCCESS = "DELETE_PATHOLOGY_SUCCESS",
  DELETE_PATHOLOGY_ERROR = "DELETE_PATHOLOGY_ERROR",
}

interface GetMarkupPathologyAction {
  type: PathologyActionTypes.GET_MARKUP_PATHOLOGY;
}

interface GetMarkupPathologySuccessAction {
  type: PathologyActionTypes.GET_MARKUP_PATHOLOGY_SUCCESS;
  payload: PathologyParams;
}

interface GetMarkupPathologyErrorAction {
  type: PathologyActionTypes.GET_MARKUP_PATHOLOGY_ERROR;
  payload: string;
}

interface GetPathologyAction {
  type: PathologyActionTypes.GET_PATHOLOGY;
}

interface GetPathologySuccessAction {
  type: PathologyActionTypes.GET_PATHOLOGY_SUCCESS;
  payload: PathologyParams;
}

interface GetPathologyErrorAction {
  type: PathologyActionTypes.GET_PATHOLOGY_ERROR;
  payload: string;
}

interface SaveMarkupPathologyAction {
  type: PathologyActionTypes.SAVE_MARKUP_PATHOLOGY;
}

interface SaveMarkupPathologySuccessAction {
  type: PathologyActionTypes.SAVE_MARKUP_PATHOLOGY_SUCCESS;
}

interface SaveMarkupPathologyErrorAction {
  type: PathologyActionTypes.SAVE_MARKUP_PATHOLOGY_ERROR;
  payload: string;
}

interface ValidatePathologyAction {
  type: PathologyActionTypes.VALIDATE_PATHOLOGY;
}

interface ValidatePathologySuccessAction {
  type: PathologyActionTypes.VALIDATE_PATHOLOGY_SUCCESS;
}

interface ValidatePathologyErrorAction {
  type: PathologyActionTypes.VALIDATE_PATHOLOGY_ERROR;
  payload: string;
}

interface DeletePathologyAction {
  type: PathologyActionTypes.DELETE_PATHOLOGY;
}

interface DeletePathologySuccessAction {
  type: PathologyActionTypes.DELETE_PATHOLOGY_SUCCESS;
}

interface DeletePathologyErrorAction {
  type: PathologyActionTypes.DELETE_PATHOLOGY_ERROR;
  payload: string;
}

export type pathologyAction =
  | GetMarkupPathologyAction
  | GetMarkupPathologySuccessAction
  | GetMarkupPathologyErrorAction
  | GetPathologyAction
  | GetPathologySuccessAction
  | GetPathologyErrorAction
  | SaveMarkupPathologyAction
  | SaveMarkupPathologySuccessAction
  | SaveMarkupPathologyErrorAction
  | ValidatePathologyAction
  | ValidatePathologySuccessAction
  | ValidatePathologyErrorAction
  | DeletePathologyAction
  | DeletePathologySuccessAction
  | DeletePathologyErrorAction;
